import { render, staticRenderFns } from "./bodyAnalysis.vue?vue&type=template&id=cc30e230&scoped=true&"
import script from "./bodyAnalysis.vue?vue&type=script&lang=js&"
export * from "./bodyAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./bodyAnalysis.vue?vue&type=style&index=0&id=cc30e230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc30e230",
  null
  
)

export default component.exports